/**
 * gift-card.js — trang Thẻ quà tặng (mục 25): bản xem trước cập nhật trực tiếp theo
 * form, bộ đếm lời nhắn, kiểm tra người nhận và thêm thẻ vào giỏ demo.
 *
 * Markup: form[data-gift-form] chứa radio name="gc_design" / "gc_amount",
 *   [data-gift-to] [data-gift-contact] [data-gift-message] [data-gift-count];
 *   [data-gift-preview] (data-design) và mọi [data-gift-out="to|message|amount"]
 *   trong trang (thẻ xem trước + chữ trên nút mua) nhận giá trị in ra.
 *
 * Thẻ vào giỏ là một "sản phẩm" id gift-card-<mệnh giá> (cùng mệnh giá thì cộng dồn
 * số lượng như chai vang cùng loại), meta "Thẻ quà tặng · gửi <tên>" để giỏ hàng
 * và mini cart in được ngay mà không cần biết gì về thẻ quà.
 *
 * WP: plugin gift card lo thêm vào giỏ (form.cart submit) — chỉ giữ phần xem trước
 * + bộ đếm; đổi selector sang name của plugin.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var form = document.querySelector('[data-gift-form]');
    if (!form) return;

    var MAX_MESSAGE = 80;
    var preview = document.querySelector('[data-gift-preview]');
    var toInput = form.querySelector('[data-gift-to]');
    var contact = form.querySelector('[data-gift-contact]');
    var message = form.querySelector('[data-gift-message]');
    var counter = form.querySelector('[data-gift-count]');
    var outputs = [].slice.call(document.querySelectorAll('[data-gift-out]'));

    var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    // Số VN: 0xxxxxxxxx hoặc +84xxxxxxxxx, cho phép dấu cách / chấm / gạch giữa các cụm
    var PHONE = /^(\+?84|0)\d{9,10}$/;

    function money(value) {
        return window.WBStore ? window.WBStore.money(value) : Number(value).toLocaleString('vi-VN') + '₫';
    }

    function radio(name) {
        return form.querySelector('input[name="' + name + '"]:checked');
    }

    function state() {
        var design = radio('gc_design');
        var amount = radio('gc_amount');
        return {
            design: design ? design.value : 'red',
            amount: amount ? Number(amount.value) : 0,
            to: toInput.value.trim(),
            message: message.value.trim()
        };
    }

    function render() {
        var s = state();
        var values = {
            to: s.to || 'người nhận',
            message: s.message || 'Lời chúc của bạn',
            amount: money(s.amount)
        };

        if (preview) {
            preview.setAttribute('data-design', s.design);
            preview.setAttribute('aria-label', 'Xem trước thẻ quà tặng ' + values.amount + ' gửi ' + values.to);
        }
        outputs.forEach(function (el) {
            el.textContent = values[el.getAttribute('data-gift-out')];
        });
        // maxlength đã chặn gõ quá 80; độ dài tính trên chuỗi NFC để chữ có dấu tiếng
        // Việt (ế, ộ…) đếm 1 ký tự như người dùng thấy, không phải 2–3 code point.
        if (counter) {
            var raw = message.value.normalize ? message.value.normalize('NFC') : message.value;
            counter.textContent = Math.min(raw.length, MAX_MESSAGE) + '/' + MAX_MESSAGE;
        }
    }

    // ----- Kiểm tra trước khi thêm vào giỏ -----
    function setError(input, invalid) {
        var field = input.closest('.field');
        var error = document.getElementById(input.getAttribute('aria-describedby'));
        field.classList.toggle('field--error', invalid);
        input.setAttribute('aria-invalid', invalid ? 'true' : 'false');
        if (error) error.hidden = !invalid;
        return invalid;
    }

    function validContact(value) {
        var compact = value.replace(/[\s.\-]/g, '');
        return EMAIL.test(value) || PHONE.test(compact);
    }

    function validate() {
        var badTo = setError(toInput, !toInput.value.trim());
        var badContact = setError(contact, !validContact(contact.value.trim()));
        if (badTo) toInput.focus();
        else if (badContact) contact.focus();
        return !badTo && !badContact;
    }

    function addToCart(event) {
        event.preventDefault();
        if (!validate() || !window.WBStore) return;

        var s = state();
        var snap = {
            id: 'gift-card-' + s.amount,
            name: 'Thẻ quà tặng WINEBOSS ' + money(s.amount),
            price: s.amount,
            regularPrice: 0,
            image: 'images/products/bottle.png',
            url: 'gift-card.html',
            meta: 'Thẻ quà tặng · gửi ' + s.to,
            type: 'Thẻ quà tặng',
            giftCard: { design: s.design, to: s.to, contact: contact.value.trim(), message: s.message }
        };
        window.WBStore.cart.add(snap, 1);

        if (window.WBToast) {
            window.WBToast.show('Đã thêm thẻ quà tặng ' + money(s.amount) + ' vào giỏ hàng', {
                icon: 'ph-fill ph-gift',
                action: { label: 'Xem giỏ', href: 'cart.html' }
            });
        }
    }

    form.addEventListener('input', function (event) {
        // Sửa lại ô đang báo lỗi thì gỡ lỗi ngay, không đợi bấm mua lần nữa
        if (event.target.getAttribute('aria-invalid') === 'true') {
            if (event.target === toInput && toInput.value.trim()) setError(toInput, false);
            if (event.target === contact && validContact(contact.value.trim())) setError(contact, false);
        }
        render();
    });
    form.addEventListener('change', render);
    form.addEventListener('submit', addToCart);

    // Trình duyệt giữ giá trị form khi quay lại trang (bfcache) — vẽ lại theo đúng form
    window.addEventListener('pageshow', render);
    render();
})();
